import { TFunction } from 'i18next';
import { RelationshipType, Scorecard } from '../../../../generated/graphql';

export function scoreCalculationTooltipCalculationScorecardValuesFromScorecard(
  scorecard: Scorecard | undefined | null
) {
  return {
    annualDebtPayments: scorecard?.annualDebtPayments,
    annualExpenses: scorecard?.annualExpenses,
    annualIncome: scorecard?.annualIncome,
    annualSavings: scorecard?.annualSavings,
    businessEquity: scorecard?.businessEquity,
    liquidity: scorecard?.liquidity,
    netWorth: scorecard?.netWorth,
    mostRecentTaxedIncome: scorecard?.mostRecentTaxedIncome,
    mostRecentTaxesPaid: scorecard?.mostRecentTaxesPaid,
    mostRecentTaxYear: scorecard?.mostRecentTaxYear,
    qualifiedAssets: scorecard?.qualifiedAssets,
    realEstateEquity: scorecard?.realEstateEquity,
    equityMix: scorecard?.equityMix,
    investmentsAndCash: scorecard?.investmentsAndCash,
    disabilityCoverages: scorecard?.disabilityCoverages,
    liabilityCoverage: scorecard?.liabilityCoverages,
    lifeCoverages: scorecard?.lifeCoverages,
  };
}

export const getTooltipDisplayFromRelationship = (
  translation: TFunction<'scorecard'>,
  relationship: string
): string => {
  switch (relationship) {
    case RelationshipType.HeadOfHousehold:
      return translation('ir-tooltip-head-of-household');

    case RelationshipType.Husband:
      return translation('ir-tooltip-spouse');

    case RelationshipType.Wife:
      return translation('ir-tooltip-spouse');

    case RelationshipType.Partner:
      return translation('ir-tooltip-partner');

    default:
      return translation('ir-tooltip-other-relationship');
  }
};
